import {useLocalStorage} from "@vueuse/core";

export const sidebar_open = useLocalStorage('sidebar_open', false);
